import { defineMessages } from "react-intl";

const VISIT_EBSCO_HELP_LINK = "visit-ebsco-help-link";

const visitEbscoHelpLinkMessages = defineMessages({
  visitEbscoHelp: {
    id: `${VISIT_EBSCO_HELP_LINK}.visit-ebsco-help`,
    defaultMessage: "Visit EBSCO help"
  }
});

export default visitEbscoHelpLinkMessages;
